<template>
  <b-row class="pb-2" v-if="getInfoItem.dataItensPedido.imagens.length > 0">
    <b-col cols="auto" class="imagens-container">
      <div
          class="imagens-item"
      >
        <div
            v-if="getInfoItem.dataItensPedido.imagens.length > 0"
            v-for="(img, index) in getInfoItem.dataItensPedido.imagens.slice(0, 5)" :key="index">
          <div
              class="rounded imagens-item-img"
          >
            <b-img
                :src="img.caminho ? img.caminho : imagemPadrao"
                :alt="`${getInfoItem.dataItensPedido.item_name}-${getInfoItem.dataItensPedido.item_id}`"
                class="img-fluid"
                @click="$store.commit('intensPedido/SET_IMAGEM_PRINCIPAL', img.caminho)"
                @mouseover="$store.commit('intensPedido/SET_IMAGEM_PRINCIPAL', img.caminho)"
            />

          </div>
        </div>
        <!-- Verificar se há mais imagens após a sexta -->
        <div
            v-if="getInfoItem.dataItensPedido.imagens.length > 5"
            class="d-flex justify-content-center align-items-center bg-grey-1 rounded"
            style="border: 1px solid var(--primary); width: 50px; height: 50px;"
            v-b-modal.modal-gallery-imagens
        >
          +{{ getInfoItem.dataItensPedido.imagens.length - 5 }} <!-- Mostrar a quantidade restante -->
        </div>
      </div>
    </b-col>
    <b-col
        cols="12"
        md="2"
    >
      <b-img
          :src="getInfoItem.dataItensPedido.item_img_princial ? getInfoItem.dataItensPedido.item_img_princial : imagemPadrao"
          :alt="`${getInfoItem.dataItensPedido.item_name}-${getInfoItem.dataItensPedido.item_id}`"
          style="height: 350px"
          class="img-fluid"
      />
    </b-col>
<!--    <b-col-->
<!--        cols="12"-->
<!--        md="9"-->
<!--    >-->
<!--      <grade-item-->
<!--          :json = "json"-->
<!--          v-model="getInfoItem.dataItensPedido.gradeItem"  @update:grade="updatedGrade"  />-->
<!--&lt;!&ndash;      <grade-pedidos/>&ndash;&gt;-->
<!--    </b-col>-->
    <b-modal
        id="modal-gallery-imagens"
        hide-footer
        hide-header
        style="height: 500px; width: 100%;background: transparent; border: none; padding: 0; margin: 0;"
        body-bg-variant="transparent"
    >
      <swiper
          ref="refSwiperGallery"
          class="swiper-gallery gallery-top"
          :options="swiperOptions"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
      >
        <swiper-slide
            v-for="(data,index) in getInfoItem.dataItensPedido.imagens"
            :key="index"
        >
          <b-img
              :src="data.caminho"
              fluid
          />
        </swiper-slide>

        <div
            slot="button-next"
            class="swiper-button-next swiper-button-white"
        />
        <div
            slot="button-prev"
            class="swiper-button-prev swiper-button-white"
        />
      </swiper>
    </b-modal>
  </b-row>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { mapGetters } from 'vuex';
import GradePedidos from '@/views/app/operacoes/pedidosVendas/tabelaGrade/gradePedidos.vue';
import GradeItem from '@/components/catalogo-produtos/GradeItem.vue';
import { IMAGEM_PADRAO } from '@/utils/imagemUrl';

export default {
  name: 'ProductionItem',
  props: {
    json: {
      type: Array,
      required: true,
    },
  },
  components: {
    GradeItem,
    GradePedidos,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      imagemPadrao: IMAGEM_PADRAO,
      swiperOptions: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 4,
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
    };
  },

  computed: {
    getInfoItem: {
      get() {
        return this.$store.getters['intensPedido/getFormData'];
      },
      set(value) {
        this.$store.commit('intensPedido/SET_DETALHES_ITEM', value);
      },
    },

  },
  methods: {
    updatedGrade(value) {
      this.$emit('update:grade-item', value);
    },
  },
};
</script>
<style lang="scss">
.imagens-container {

}

.imagens-item-img {
  border: 1px solid var(--primary);
  width: 50px;
  height: 50px;
}

.imagens-item-img img {
  height: 50px;
}

.imagens-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .imagens-container {
    width: 100%;
    padding-bottom: 10px;
  }

  .imagens-item {
    flex-direction: row;
  }

  .imagens-item-img img {
    //width: 100px;
    //height: 100px;
  }
}

/* Estilize a modal e o swiper conforme necessário */
.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide img {
  width: 100%;
  height: 100%;
}
</style>
